import { db } from '$db/local/db';
import type { ReviewEvent, ReviewRating, UUID } from '$domain/types';
import { getActiveUserId } from '$core/identity/active-user';
import { newId } from './common';

export interface CreateReviewEventInput {
  recallItemId: UUID;
  rating: ReviewRating;
  scheduledDays: number;
  elapsedDays: number;
  durationMs: number;
  consultedSolution: boolean;
  reviewedAt: string;
}

export async function createReviewEvent(
  input: CreateReviewEventInput
): Promise<ReviewEvent> {
  const event: ReviewEvent = {
    id: newId(),
    userId: getActiveUserId(),
    recallItemId: input.recallItemId,
    rating: input.rating,
    scheduledDays: input.scheduledDays,
    elapsedDays: input.elapsedDays,
    durationMs: input.durationMs,
    consultedSolution: input.consultedSolution,
    reviewedAt: input.reviewedAt
  };
  await db.reviewEvents.add(event);
  return event;
}

export async function listEventsByItem(recallItemId: UUID): Promise<ReviewEvent[]> {
  const rows = await db.reviewEvents.where('recallItemId').equals(recallItemId).toArray();
  return rows.sort((a, b) => a.reviewedAt.localeCompare(b.reviewedAt));
}

export async function countReviewEvents(
  userId = getActiveUserId()
): Promise<number> {
  return db.reviewEvents.where('userId').equals(userId).count();
}

export async function listReviewEventsByUser(
  userId = getActiveUserId()
): Promise<ReviewEvent[]> {
  const rows = await db.reviewEvents.where('userId').equals(userId).toArray();
  return rows.sort((a, b) => a.reviewedAt.localeCompare(b.reviewedAt));
}